import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Card } from '@redlink/components/atoms';

export const ReportSummaryItem = memo(
  ({
    withContainer = false,
    title,
    value,
    valuePostfix = '',
    change = 0,
    changePostfix = '',
    valueFormatter = (v) => v,
    style,
    changeTextStyle,
    children,
  }) => {
    const { styles } = useStyle();

    return (
      <Container {...{ withContainer }} style={[styles.container, style]}>
        <Text style={styles.titleText}>{title}</Text>
        {children}
        <View style={styles.numbersContainer}>
          <ReportChangeText
            value={change}
            postfix={changePostfix}
            style={changeTextStyle}
          />
          <Text style={styles.mainNumberText}>
            {valueFormatter(value)}
            <Text style={styles.valuePostfixText}>{valuePostfix}</Text>
          </Text>
        </View>
      </Container>
    );
  }
);

const Container = memo(({ withContainer, ...rest }) => {
  return withContainer ? <Card {...rest} /> : <View {...rest} />;
});

export const ReportChangeText = memo(({ value, postfix = '', style }) => {
  const { styles } = useStyle();
  const hasChange = value !== 0;
  const isIncreaseChange = value > 0;
  return hasChange ? (
    <Text
      style={[
        styles.changeText,
        style,
        hasChange && isIncreaseChange && styles.incereaseChangeText,
        hasChange && !isIncreaseChange && styles.decreaseChangeText,
      ]}
    >
      {`${isIncreaseChange ? value : `(${value})`}${postfix}`}
    </Text>
  ) : null;
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {},
  titleText: {
    color: colors.gray21,
    fontSize: 12,
  },
  numbersContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  mainNumberText: {
    fontSize: 20,
    color: colors.black
  },
  changeText: {
    fontSize: 16,
    color: colors.black
  },
  incereaseChangeText: {
    color: colors.green2,
  },
  decreaseChangeText: {
    color: colors.red1,
  },
  valuePostfixText: {
    fontSize: 14,
  },
}));
